(() => {
  const overlay = document.getElementById('CapSearchOverlay');
  if (!overlay) return;

  /* CAP fix: l'overlay deve stare direttamente nel body, fuori dallo stacking context
     dell'header sticky. Così non passa mai sotto menu, banner o sezioni della home. */
  if (overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }

  const header = document.getElementById('capHeader');
  const headerForm = header ? header.querySelector('.cap-header-search .cap-search-form') : null;
  const headerInput = headerForm ? headerForm.querySelector('.cap-search-input') : null;
  const headerButton = headerForm ? headerForm.querySelector('.cap-search-btn') : null;

  const body = overlay.querySelector('.cap-search-overlay__body');
  const dialogForm = overlay.querySelector('.cap-search-overlay__form');
  const dialogInput = overlay.querySelector('.cap-search-overlay__input');
  const resetButton = overlay.querySelector('[data-cap-search-reset]');
  const loadingState = overlay.querySelector('[data-cap-search-loading]');
  const emptyState = overlay.querySelector('[data-cap-search-empty]');
  const resultsState = overlay.querySelector('[data-cap-search-results]');
  const recentList = overlay.querySelector('[data-cap-search-recent-list]');
  const recentEmpty = overlay.querySelector('[data-cap-search-recent-empty]');
  const recentActions = overlay.querySelector('[data-cap-search-recent-actions]');
  const clearAllButton = overlay.querySelector('[data-cap-search-clear-all]');
  const closeButtons = overlay.querySelectorAll('[data-cap-search-close]');

  const RECENT_KEY = 'cap-search-recent-v1';
  const SEARCH_ROOT = '/search';
  const SEARCH_DELAY = 220;
  const MOBILE_MEDIA = window.matchMedia('(max-width: 989px)');
  const CATEGORY_TREE_ID = 'CapSearchOverlayCategoryTree';

  function normalizeKey(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/&/g, ' e ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function parseCategoryTree() {
    const node = overlay.querySelector(`#${CATEGORY_TREE_ID}`) || document.getElementById(CATEGORY_TREE_ID);
    if (!node) return [];
    try {
      const parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  const CATEGORY_TREE = parseCategoryTree();

  function hasCategoryTree() {
    return Array.isArray(CATEGORY_TREE) && CATEGORY_TREE.length > 0;
  }

  function getCategoryOptionObjects(source) {
    if (!source) return [];
    return Array.from(source.querySelectorAll('.mobile-facets__checkbox')).map((input, index) => {
      const labelNode = input.closest('label');
      const labelText = normalizeFacetLabel(labelNode?.querySelector('.facet-checkbox__text-label')?.textContent || labelNode?.textContent || input.value);
      const countText = normalizeFacetLabel(labelNode?.querySelector('.facet-checkbox__text-count')?.textContent || '');
      return {
        id: `${normalizeKey(labelText || input.value)}-${index}`,
        name: input.name,
        value: input.value,
        label: labelText,
        count: countText,
        checked: input.checked,
        disabled: input.disabled,
        input
      };
    });
  }

  function getMeaningfulTokens(value) {
    return normalizeKey(value)
      .split(' ')
      .map((token) => token.trim())
      .filter((token) => token && token.length > 2)
      .filter((token) => !['con', 'per', 'del', 'della', 'delle', 'degli', 'dello', 'alla', 'alle', 'agli', 'allo', 'nella', 'nelle', 'negli', 'nello', 'sul', 'sulla', 'sulle', 'sugli', 'da', 'di', 'e', 'il', 'lo', 'la', 'i', 'gli', 'le'].includes(token));
  }

  function getNodeMatchKeys(node) {
    if (!node) return [];
    return [
      normalizeKey(node.title),
      normalizeKey(node.handle),
      normalizeKey((node.url || '').split('/').filter(Boolean).pop())
    ].filter(Boolean);
  }

  function getOptionMatchKeys(option) {
    if (!option) return [];
    return [
      normalizeKey(option.label),
      normalizeKey(option.value)
    ].filter(Boolean);
  }

  function scoreNodeOptionMatch(node, option) {
    if (!node || !option || option._used) return -1;

    const nodeKeys = getNodeMatchKeys(node);
    const optionKeys = getOptionMatchKeys(option);

    if (!nodeKeys.length || !optionKeys.length) return -1;

    for (const nodeKey of nodeKeys) {
      for (const optionKey of optionKeys) {
        if (nodeKey && optionKey && nodeKey === optionKey) return 100;
      }
    }

    const nodeTokens = new Set(nodeKeys.flatMap((key) => getMeaningfulTokens(key)));
    const optionTokens = new Set(optionKeys.flatMap((key) => getMeaningfulTokens(key)));
    if (!nodeTokens.size || !optionTokens.size) return -1;

    let overlap = 0;
    nodeTokens.forEach((token) => {
      if (optionTokens.has(token)) overlap += 1;
    });

    if (!overlap) return -1;

    const smallest = Math.min(nodeTokens.size, optionTokens.size);
    const largest = Math.max(nodeTokens.size, optionTokens.size);
    if (overlap < smallest) return -1;

    return 60 + overlap - (largest - smallest);
  }

  function findCategoryOptionForNode(node, options) {
    if (!node) return null;

    let bestOption = null;
    let bestScore = -1;

    (options || []).forEach((option) => {
      const score = scoreNodeOptionMatch(node, option);
      if (score > bestScore) {
        bestScore = score;
        bestOption = option;
      }
    });

    return bestScore >= 60 ? bestOption : null;
  }

  function buildCategoryTreeNodes(menuItems, options) {
    return (menuItems || []).map((item) => {
      const node = {
        title: normalizeFacetLabel(item.title),
        url: item.url || '',
        handle: item.handle || '',
        children: []
      };

      const matchedOption = findCategoryOptionForNode(node, options);
      if (matchedOption) {
        matchedOption._used = true;
        node.optionId = matchedOption.id;
      }

      node.children = buildCategoryTreeNodes(item.children || [], options);
      if (!node.optionId && !node.children.length) return null;
      return node;
    }).filter(Boolean);
  }

  function findTreeNodeByOptionId(nodes, optionId) {
    for (const node of nodes || []) {
      if (node.optionId === optionId) return node;
      const childHit = findTreeNodeByOptionId(node.children || [], optionId);
      if (childHit) return childHit;
    }
    return null;
  }

  function treeNodeContainsOptionId(node, optionId) {
    if (!node || !optionId) return false;
    if (node.optionId === optionId) return true;
    return (node.children || []).some((child) => treeNodeContainsOptionId(child, optionId));
  }

  function getTreePathByOptionId(nodes, optionId, trail = []) {
    for (const node of nodes || []) {
      const nextTrail = trail.concat(node);
      if (node.optionId === optionId) return nextTrail;
      const childHit = getTreePathByOptionId(node.children || [], optionId, nextTrail);
      if (childHit.length) return childHit;
    }
    return [];
  }


  function formatCategoryRemovalLabel(nodes, options, optionId) {
    const option = (options || []).find((item) => item.id === optionId) || null;
    if (!option) return 'questa categoria';
    const trail = getTreePathByOptionId(nodes || [], optionId);
    const parent = trail.length > 1 ? trail[trail.length - 2] : null;
    if (parent && normalizeKey(parent.title) !== normalizeKey(option.label)) {
      return `${parent.title} / ${option.label}`;
    }
    return option.label;
  }

  function renderCategoryTreeNodes(nodes, optionsById, activeOptionId, depth = 0) {
    return (nodes || []).map((node, index) => renderCategoryTreeNode(node, optionsById, activeOptionId, depth, `${depth}-${index}`)).join('');
  }

  function renderCategoryTreeNode(node, optionsById, activeOptionId, depth, path) {
    const option = node.optionId ? optionsById.get(node.optionId) : null;
    const children = Array.isArray(node.children) ? node.children : [];
    const hasChildren = children.length > 0;
    const isSelfActive = !!(option && option.id === activeOptionId);
    const hasActiveInside = !!(activeOptionId && (isSelfActive || (hasChildren && treeNodeContainsOptionId(node, activeOptionId))));
    const leafCountMarkup = option && option.count ? `<span class="cap-mobile-category-leaf__count">${escapeHtml(option.count)}</span>` : '';
    const branchCountMarkup = option && option.count ? `<span class="cap-mobile-category-branch__count">${escapeHtml(option.count)}</span>` : '';
    const activeClass = isSelfActive ? ' is-active' : '';
    const branchActiveClass = hasActiveInside ? ' is-active-branch' : '';

    if (hasChildren && !option && depth > 0) {
      return renderCategoryTreeNodes(children, optionsById, activeOptionId, depth, path);
    }

    if (hasChildren) {
      return `
        <div class="cap-mobile-category-branch-wrap${branchActiveClass}" data-cap-tree-path="${escapeHtml(path)}">
          <button type="button" class="cap-mobile-category-branch" data-cap-tree-toggle aria-expanded="false">
            <span class="cap-mobile-category-branch__title">${escapeHtml(node.title)}</span>
            <span class="cap-mobile-category-branch__right">
              ${branchCountMarkup}
            <span class="cap-mobile-category-branch__check" aria-hidden="true">✓</span>
              <span class="cap-mobile-category-branch__icon" aria-hidden="true">
                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 4.5L12.5 10L7 15.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </span>
            </span>
          </button>
          <div class="cap-mobile-category-children" hidden>
            ${renderCategoryTreeNodes(children, optionsById, activeOptionId, depth + 1)}
          </div>
        </div>`;
    }

    if (!option) return '';

    return `
      <button
        type="button"
        class="cap-mobile-category-leaf${activeClass}"
        data-cap-tree-select="${escapeHtml(option.id)}"
      >
        <span class="cap-mobile-category-leaf__label">${escapeHtml(node.title)}</span>
        <span class="cap-mobile-category-leaf__meta">${leafCountMarkup}<span class="cap-mobile-category-leaf__check">✓</span></span>
      </button>`;
  }

  function renderCategoryTreeSheet(sheet, definition, mobileForm) {
    const body = sheet.querySelector('.cap-mobile-filter-sheet__body');
    const footer = sheet.querySelector('.cap-mobile-filter-sheet__footer');
    const options = getCategoryOptionObjects(definition.source);
    const treeNodes = buildCategoryTreeNodes(CATEGORY_TREE, options);
    const optionsById = new Map(options.map((option) => [option.id, option]));
    const activeOption = options.find((option) => option.checked) || null;
    const activeTrail = activeOption ? getTreePathByOptionId(treeNodes, activeOption.id) : [];
    const activeParent = activeTrail.length > 1 ? activeTrail[activeTrail.length - 2] : null;
    const activeTrailLabels = [];
    if (activeParent && activeParent.title) activeTrailLabels.push(activeParent.title);
    if (activeOption && (!activeParent || normalizeKey(activeParent.title) !== normalizeKey(activeOption.label))) activeTrailLabels.push(activeOption.label);
    const activeTrailMarkup = activeTrailLabels.length
      ? activeTrailLabels.map((label) => `<span class="cap-mobile-category-active__crumb">${escapeHtml(label)}</span>`).join('<span class="cap-mobile-category-active__sep">/</span>')
      : '';
    const leftovers = options.filter((option) => !option._used);

    sheet.dataset.mode = 'category-tree';
    footer.classList.add('is-hidden');
    footer.innerHTML = '';

    body.innerHTML = `
      ${activeOption ? `
        <div class="cap-mobile-category-active">
          <div class="cap-mobile-category-active__content">
            <span class="cap-mobile-category-active__eyebrow">Categoria attiva</span>
            ${activeTrailMarkup ? `<div class="cap-mobile-category-active__trail">${activeTrailMarkup}</div>` : ''}
            <strong class="cap-mobile-category-active__label">${escapeHtml(activeOption.label)}</strong>
          </div>
          <button type="button" class="cap-mobile-category-active__remove" data-cap-tree-remove-active="${escapeHtml(activeOption.id)}">Rimuovi</button>
        </div>` : ''}
      <div class="cap-mobile-category-tree">
        ${renderCategoryTreeNodes(treeNodes, optionsById, activeOption ? activeOption.id : '')}
        ${leftovers.length ? `
          <details class="cap-mobile-category-extra">
            <summary>Altre categorie</summary>
            <div class="cap-mobile-category-extra__list">
              ${leftovers.map((option) => `
                <button
                  type="button"
                  class="cap-mobile-category-leaf${option.checked ? ' is-active' : ''}"
                  data-cap-tree-select="${escapeHtml(option.id)}"
                >
                  <span class="cap-mobile-category-leaf__label">${escapeHtml(option.label)}</span>
                  <span class="cap-mobile-category-leaf__meta">${option.count ? `<span class="cap-mobile-category-leaf__count">${escapeHtml(option.count)}</span>` : ''}<span class="cap-mobile-category-leaf__check">✓</span></span>
                </button>`).join('')}
            </div>
          </details>` : ''}
      </div>`;
  }

  let isOpen = false;
  let debounceTimer = null;
  let activeController = null;
  let lastFetchedUrl = '';
  let lastSearchedTerm = '';
  let pendingRecentTerm = '';

  function safeJsonParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (_) {
      return fallback;
    }
  }

  function getRecentTerms() {
    try {
      const parsed = safeJsonParse(window.localStorage.getItem(RECENT_KEY), []);
      return Array.isArray(parsed) ? parsed.filter((item) => normalizeTerm(item)) : [];
    } catch (_) {
      return [];
    }
  }

  function setRecentTerms(terms) {
    try {
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(Array.isArray(terms) ? terms : []));
    } catch (_) {
      // ignore storage errors
    }
  }

  function normalizeTerm(term) {
    return String(term || '').replace(/\s+/g, ' ').trim();
  }

  function renderRecentTerms() {
    const terms = getRecentTerms();
    if (!recentList) return;
    recentList.innerHTML = '';

    if (!terms.length) {
      if (recentEmpty) recentEmpty.hidden = false;
      if (recentActions) recentActions.hidden = true;
      return;
    }

    if (recentEmpty) recentEmpty.hidden = true;
    if (recentActions) recentActions.hidden = false;

    terms.forEach((term) => {
      const item = document.createElement('li');
      item.className = 'cap-search-overlay__recent-item';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cap-search-overlay__recent-btn';
      button.setAttribute('data-cap-search-term', term);
      button.innerHTML = `
        <span class="svg-wrapper" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 12a9 9 0 1 0 3-6.708" />
            <path d="M3 4v5h5" />
            <path d="M12 7v5l3 2" />
          </svg>
        </span>
        <span>${escapeHtml(term)}</span>
      `;

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cap-search-overlay__recent-remove';
      remove.setAttribute('data-cap-search-remove-term', term);
      remove.setAttribute('aria-label', `Rimuovi ${term}`);
      remove.textContent = '×';

      item.appendChild(button);
      item.appendChild(remove);
      recentList.appendChild(item);
    });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function rememberRecentTerm(term) {
    const normalized = normalizeTerm(term);
    if (normalized) pendingRecentTerm = normalized;
  }

  function saveRecentTerm(term) {
    const normalized = normalizeTerm(term);
    if (!normalized) return;

    const current = getRecentTerms().filter((item) => item.toLowerCase() !== normalized.toLowerCase());
    current.unshift(normalized);
    setRecentTerms(current.slice(0, 6));
    renderRecentTerms();
  }

  function removeRecentTerm(term) {
    const normalized = normalizeTerm(term);
    const next = getRecentTerms().filter((item) => item.toLowerCase() !== normalized.toLowerCase());
    setRecentTerms(next);
    renderRecentTerms();
  }

  function clearRecentTerms() {
    setRecentTerms([]);
    renderRecentTerms();
  }

  function buildSearchUrl(queryOrParams) {
    if (queryOrParams instanceof URLSearchParams) {
      const params = queryOrParams;
      if (!params.get('type')) params.set('type', 'product');
      if (!params.get('options[prefix]')) params.set('options[prefix]', 'last');
      return `${SEARCH_ROOT}?${params.toString()}`;
    }

    const params = new URLSearchParams();
    params.set('q', normalizeTerm(queryOrParams));
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    return `${SEARCH_ROOT}?${params.toString()}`;
  }

  function toggleResetButton() {
    if (!resetButton || !dialogInput) return;
    resetButton.hidden = !normalizeTerm(dialogInput.value);
  }

  function showEmptyState() {
    if (emptyState) emptyState.hidden = false;
    if (loadingState) loadingState.hidden = true;
    if (resultsState) {
      resultsState.hidden = true;
      resultsState.innerHTML = '';
    }
    if (body) body.scrollTop = 0;
    if (activeController) {
      activeController.abort();
      activeController = null;
    }
    lastFetchedUrl = '';
    lastSearchedTerm = '';
  }

  function showLoadingState() {
    if (emptyState) emptyState.hidden = true;
    if (loadingState) loadingState.hidden = false;
    if (resultsState) resultsState.hidden = true;
  }

  function isMobileFacetsForm(form) {
    if (!form) return false;
    const formId = form.id || '';
    return form.classList.contains('mobile-facets') || formId === 'FacetFiltersFormMobile' || formId.startsWith('FacetFiltersFormMobile-');
  }

  function getMobileFacetsForm(root = resultsState) {
    if (!root) return null;
    return root.querySelector('form.mobile-facets') || root.querySelector('[id^="FacetFiltersFormMobile"]');
  }

  function getResultsCountText(root = resultsState, form = null) {
    const countFromForm = form ? form.querySelector('[data-mobile-results-count]') : null;
    if (countFromForm) return countFromForm.textContent.replace(/\s+/g, ' ').trim();

    const countNode = root ? root.querySelector('.product-count.light .product-count__text') : null;
    if (countNode) return countNode.textContent.replace(/\s+/g, ' ').trim();

    return '';
  }

  function normalizeFacetLabel(label) {
    return String(label || '').replace(/\s+/g, ' ').trim();
  }

  function getFilterOrderScore(definition) {
    const label = normalizeFacetLabel(definition.label).toLowerCase();
    if (label.includes('categor')) return 10;
    if (definition.kind === 'price') return 20;
    if (label.includes('dispon')) return 30;
    if (label.includes('color')) return 40;
    if (definition.kind === 'sort') return 90;
    return 50;
  }

  function getMobileFilterDefinitions(form) {
    if (!form) return [];

    const definitions = [];
    const sortSelect = form.querySelector('.mobile-facets__sort-select, .mobile-facets__sort-block select');
    if (sortSelect) {
      definitions.push({
        key: 'sort',
        kind: 'sort',
        label: 'Ordina',
        source: sortSelect,
        selectionCount: 0,
        singleSelectImmediate: true
      });
    }

    form.querySelectorAll('.mobile-facets__details').forEach((details, index) => {
      const label = normalizeFacetLabel(details.querySelector('.mobile-facets__summary-main')?.textContent || details.querySelector('summary')?.textContent || `Filtro ${index + 1}`);
      const kind = details.querySelector('.facets__price') ? 'price' : 'list';
      const selectionCount = kind === 'price'
        ? (Array.from(details.querySelectorAll('.facets__price input')).some((input) => String(input.value || '').trim() !== '') ? 1 : 0)
        : details.querySelectorAll('.mobile-facets__checkbox:checked').length;
      const lower = label.toLowerCase();
      definitions.push({
        key: `filter-${index}`,
        kind,
        label,
        source: details,
        selectionCount,
        singleSelectImmediate: lower.includes('categor')
      });
    });

    return definitions.sort((a, b) => getFilterOrderScore(a) - getFilterOrderScore(b));
  }

  function renderEnhancedMobileFilters(root = resultsState) {
    if (!root) return;

    root.querySelectorAll('.cap-mobile-filters-bar, .cap-mobile-filter-sheet').forEach((node) => node.remove());

    if (!MOBILE_MEDIA.matches) return;

    const form = getMobileFacetsForm(root);
    const facetsContainer = root.querySelector('.facets-container');
    if (!form || !facetsContainer) return;

    const definitions = getMobileFilterDefinitions(form);
    if (!definitions.length) return;

    const countText = getResultsCountText(root, form);
    const chips = collectMobileFacetChips(form);

    const bar = document.createElement('div');
    bar.className = 'cap-mobile-filters-bar';
    bar.innerHTML = `
      <div class="cap-mobile-filters-bar__top">
        <div class="cap-mobile-filters-bar__count">${escapeHtml(countText || '')}</div>
        <button type="button" class="cap-mobile-filters-bar__clear${chips.length ? '' : ' is-hidden'}" data-cap-mobile-clear-all>Rimuovi tutto</button>
      </div>
      <div class="cap-mobile-filters-bar__pills">
        ${definitions.map((definition) => `
          <button type="button" class="cap-mobile-filters-pill${definition.selectionCount ? ' is-active' : ''}" data-cap-open-filter="${escapeHtml(definition.key)}">
            <span>${escapeHtml(definition.label)}</span>
            ${definition.selectionCount ? `<span class="cap-mobile-filters-pill__count">${definition.selectionCount}</span>` : ''}
          </button>
        `).join('')}
      </div>
      <div class="cap-mobile-filters-bar__chips${chips.length ? '' : ' is-hidden'}">
        ${chips.map((chip) => {
          if (chip.type === 'price') {
            return `<button type="button" class="cap-mobile-chip" data-cap-chip-type="price"><span>${escapeHtml(chip.label)}</span><span class="cap-mobile-chip__x">×</span></button>`;
          }
          return `<button type="button" class="cap-mobile-chip" data-cap-chip-name="${escapeHtml(chip.name)}" data-cap-chip-value="${escapeHtml(chip.value)}"><span>${escapeHtml(chip.label)}</span><span class="cap-mobile-chip__x">×</span></button>`;
        }).join('')}
      </div>
    `;

    facetsContainer.prepend(bar);

    const sheet = document.createElement('div');
    sheet.className = 'cap-mobile-filter-sheet';
    sheet.hidden = true;
    sheet.innerHTML = `
      <div class="cap-mobile-filter-sheet__backdrop" data-cap-sheet-close></div>
      <div class="cap-mobile-filter-sheet__panel" role="dialog" aria-modal="true" aria-label="Filtra e ordina">
        <div class="cap-mobile-filter-sheet__header">
          <h3 class="cap-mobile-filter-sheet__title"></h3>
          <button type="button" class="cap-mobile-filter-sheet__close" data-cap-sheet-close aria-label="Chiudi">×</button>
        </div>
        <div class="cap-mobile-filter-sheet__body"></div>
        <div class="cap-mobile-filter-sheet__footer"></div>
      </div>
    `;
    root.appendChild(sheet);
  }

  function openEnhancedMobileSheet(root, filterKey) {
    if (!root || !MOBILE_MEDIA.matches) return;

    const form = getMobileFacetsForm(root);
    const sheet = root.querySelector('.cap-mobile-filter-sheet');
    if (!form || !sheet) return;

    const definition = getMobileFilterDefinitions(form).find((item) => item.key === filterKey);
    if (!definition) return;

    const title = sheet.querySelector('.cap-mobile-filter-sheet__title');
    const body = sheet.querySelector('.cap-mobile-filter-sheet__body');
    const footer = sheet.querySelector('.cap-mobile-filter-sheet__footer');

    title.textContent = definition.label;
    body.innerHTML = '';
    footer.innerHTML = '';
    sheet.dataset.mode = definition.kind === 'sort' ? 'sort' : definition.singleSelectImmediate ? 'list-single' : definition.kind === 'price' ? 'price' : 'list-multi';
    sheet.dataset.filterKey = definition.key;

    if (definition.kind === 'sort') {
      const select = definition.source;
      body.innerHTML = `
        <div class="cap-mobile-sheet-options cap-mobile-sheet-options--sort">
          ${Array.from(select.options).map((option) => `
            <button type="button" class="cap-mobile-sheet-option${option.selected ? ' is-selected' : ''}" data-cap-sheet-sort-value="${escapeHtml(option.value)}">
              <span>${escapeHtml(option.textContent)}</span>
              <span class="cap-mobile-sheet-option__check">✓</span>
            </button>
          `).join('')}
        </div>
      `;
      footer.classList.add('is-hidden');
    } else if (definition.kind === 'list' && definition.singleSelectImmediate && hasCategoryTree()) {
      renderCategoryTreeSheet(sheet, definition, form);
    } else if (definition.kind === 'price') {
      const inputs = Array.from(definition.source.querySelectorAll('.facets__price input')).filter((input) => !input.disabled);
      const min = inputs[0]?.value || '';
      const max = inputs[1]?.value || '';
      body.innerHTML = `
        <div class="cap-mobile-price-sheet">
          <p class="cap-mobile-price-sheet__hint">Imposta il range di prezzo che vuoi vedere.</p>
          <div class="cap-mobile-price-sheet__grid">
            <label class="cap-mobile-price-sheet__field"><span>Da</span><input type="number" inputmode="decimal" value="${escapeHtml(min)}" data-cap-sheet-price="min"></label>
            <label class="cap-mobile-price-sheet__field"><span>A</span><input type="number" inputmode="decimal" value="${escapeHtml(max)}" data-cap-sheet-price="max"></label>
          </div>
        </div>
      `;
      footer.classList.remove('is-hidden');
      footer.innerHTML = `
        <button type="button" class="cap-mobile-sheet-footer__secondary" data-cap-sheet-clear>Rimuovi</button>
        <button type="button" class="cap-mobile-sheet-footer__primary" data-cap-sheet-apply>Vedi i risultati</button>
      `;
    } else {
      const options = Array.from(definition.source.querySelectorAll('.mobile-facets__checkbox')).map((input) => {
        const labelNode = input.closest('label');
        const labelText = normalizeFacetLabel(labelNode?.querySelector('.facet-checkbox__text-label')?.textContent || labelNode?.textContent || input.value);
        const countText = normalizeFacetLabel(labelNode?.querySelector('.facet-checkbox__text-count')?.textContent || '');
        return {
          name: input.name,
          value: input.value,
          label: labelText,
          count: countText,
          checked: input.checked,
          disabled: input.disabled
        };
      });

      body.innerHTML = `
        <div class="cap-mobile-sheet-options${definition.singleSelectImmediate ? ' cap-mobile-sheet-options--single' : ''}">
          ${options.map((option) => `
            <button
              type="button"
              class="cap-mobile-sheet-option${option.checked ? ' is-selected' : ''}${option.disabled ? ' is-disabled' : ''}"
              data-cap-sheet-name="${escapeHtml(option.name)}"
              data-cap-sheet-value="${escapeHtml(option.value)}"
              ${option.disabled ? 'disabled' : ''}
            >
              <span class="cap-mobile-sheet-option__label">${escapeHtml(option.label)}</span>
              <span class="cap-mobile-sheet-option__meta">
                ${option.count ? `<span class="cap-mobile-sheet-option__count">${escapeHtml(option.count)}</span>` : ''}
                <span class="cap-mobile-sheet-option__check">✓</span>
              </span>
            </button>
          `).join('')}
        </div>
      `;

      if (definition.singleSelectImmediate) {
        footer.classList.add('is-hidden');
      } else {
        footer.classList.remove('is-hidden');
        footer.innerHTML = `
          <button type="button" class="cap-mobile-sheet-footer__secondary" data-cap-sheet-clear>Rimuovi</button>
          <button type="button" class="cap-mobile-sheet-footer__primary" data-cap-sheet-apply>Vedi i risultati</button>
        `;
      }
    }

    sheet.hidden = false;
    sheet.classList.add('is-open');
    document.body.classList.add('cap-mobile-filter-sheet-open');
  }

  function closeEnhancedMobileSheet(root = resultsState) {
    if (!root) return;
    const sheet = root.querySelector('.cap-mobile-filter-sheet');
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.hidden = true;
    sheet.dataset.mode = '';
    sheet.dataset.filterKey = '';
    document.body.classList.remove('cap-mobile-filter-sheet-open');
  }

  function submitMobileFacetsForm(form, options = {}) {
    if (!form) return Promise.resolve();
    return submitOverlayForm(form, { closeDrawerOnDone: false, ...options });
  }

  function collectMobileFacetChips(form) {
    const chips = [];
    if (!form) return chips;

    form.querySelectorAll('.mobile-facets__checkbox:checked').forEach((input) => {
      const label = input.closest('label');
      const textLabel = label ? label.querySelector('.facet-checkbox__text-label') : null;
      const text = (textLabel ? textLabel.textContent : label ? label.textContent : '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      chips.push({ type: 'value', name: input.name, value: input.value, label: text });
    });

    const priceWrap = form.querySelector('.facets__price');
    if (priceWrap) {
      const priceInputs = Array.from(priceWrap.querySelectorAll('input')).filter((el) => !el.disabled);
      if (priceInputs.length >= 2) {
        const min = (priceInputs[0].value || '').trim();
        const max = (priceInputs[1].value || '').trim();
        if (min || max) {
          chips.push({ type: 'price', label: `€${min || '0'} - €${max || 'max'}` });
        }
      }
    }

    return chips;
  }

  function updateMobileFacetsUI(form) {
    if (!form) return;

    const footerTop = form.querySelector('[data-mobile-facets-footer-top]');
    const activeWrap = form.querySelector('[data-mobile-facets-active]');
    const applyButton = form.querySelector('[data-mobile-facets-apply]');
    const clearButtons = form.querySelectorAll('[data-mobile-facets-clear], [data-mobile-facets-clear-top]');
    const chips = collectMobileFacetChips(form);

    if (footerTop) footerTop.hidden = chips.length === 0;
    clearButtons.forEach((button) => button.classList.toggle('is-disabled', chips.length === 0));

    form.querySelectorAll('.mobile-facets__details').forEach((details) => {
      const summaryCount = details.querySelector('[data-mobile-summary-count]');
      if (!summaryCount) return;

      let count = 0;
      if (details.querySelector('.facets__price')) {
        const priceInputs = Array.from(details.querySelectorAll('.facets__price input')).filter((el) => !el.disabled);
        count = priceInputs.some((input) => String(input.value || '').trim() !== '') ? 1 : 0;
      } else {
        count = details.querySelectorAll('.mobile-facets__checkbox:checked').length;
      }

      summaryCount.textContent = String(count);
      summaryCount.classList.toggle('is-hidden', count === 0);
    });

    if (activeWrap) {
      activeWrap.innerHTML = chips.map((chip) => {
        if (chip.type === 'price') {
          return `<button type="button" class="active-facets__button active-facets__button--light mobile-facets__chip" data-mobile-chip-type="price"><span class="active-facets__button-inner button button--tertiary">${escapeHtml(chip.label)}<span class="svg-wrapper">×</span></span></button>`;
        }
        return `<button type="button" class="active-facets__button active-facets__button--light mobile-facets__chip" data-mobile-chip-name="${escapeHtml(chip.name)}" data-mobile-chip-value="${escapeHtml(chip.value)}"><span class="active-facets__button-inner button button--tertiary">${escapeHtml(chip.label)}<span class="svg-wrapper">×</span></span></button>`;
      }).join('');
    }

    if (applyButton) {
      applyButton.textContent = chips.length ? `Vedi i risultati (${chips.length})` : 'Vedi i risultati';
    }
  }

  function clearMobileFacetsForm(form) {
    if (!form) return;
    form.querySelectorAll('.mobile-facets__checkbox').forEach((input) => {
      input.checked = false;
    });
    form.querySelectorAll('.facets__price input').forEach((input) => {
      input.value = '';
    });
    const sortSelect = form.querySelector('.mobile-facets__sort-select');
    if (sortSelect) {
      const selected = sortSelect.querySelector('option[selected]');
      sortSelect.value = selected ? selected.value : sortSelect.options[0]?.value || sortSelect.value;
    }
    updateMobileFacetsUI(form);
  }

  function submitOverlayForm(form, options = {}) {
    if (!form) return Promise.resolve();

    const mobileFacetsForm = isMobileFacetsForm(form);
    const applyButton = mobileFacetsForm ? form.querySelector('[data-mobile-facets-apply]') : null;
    if (applyButton) {
      applyButton.disabled = true;
      applyButton.textContent = options.buttonText || 'Aggiorno...';
    }

    const request = fetchSearchResults(serializeForm(form), { persist: false });

    if (mobileFacetsForm && options.closeDrawerOnDone) {
      Promise.resolve(request).finally(() => {
        closeMobileFacetsDrawer(form);
      });
    }

    return request;
  }

  function showResultsState(html) {
    if (emptyState) emptyState.hidden = true;
    if (loadingState) loadingState.hidden = true;
    if (resultsState) {
      resultsState.hidden = false;
      resultsState.innerHTML = html;
      const mobileForm = getMobileFacetsForm(resultsState);
      if (mobileForm) updateMobileFacetsUI(mobileForm);
      renderEnhancedMobileFilters(resultsState);
    }
    if (body) body.scrollTop = 0;
  }

  function openOverlay(initialValue = '') {
    if (!dialogInput) return;
    const query = normalizeTerm(initialValue);
    pendingRecentTerm = query || pendingRecentTerm;

    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.documentElement.classList.add('cap-search-overlay-open');
    document.body.classList.add('cap-search-overlay-open');
    isOpen = true;

    dialogInput.value = query;
    toggleResetButton();
    renderRecentTerms();

    requestAnimationFrame(() => {
      dialogInput.focus({ preventScroll: true });
      dialogInput.setSelectionRange(dialogInput.value.length, dialogInput.value.length);
    });

    if (query) {
      requestSearch(query, { persist: false });
    } else {
      showEmptyState();
    }
  }

  function closeOverlay() {
    const termToSave = normalizeTerm((dialogInput && dialogInput.value) || pendingRecentTerm || lastSearchedTerm);

    if (termToSave) {
      saveRecentTerm(termToSave);
    }

    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('cap-search-overlay-open');
    document.body.classList.remove('cap-search-overlay-open');
    isOpen = false;

    if (activeController) {
      activeController.abort();
      activeController = null;
    }

    window.clearTimeout(debounceTimer);
    debounceTimer = null;
    pendingRecentTerm = '';
  }

  function closeMobileFacetsDrawer(node) {
    const wrapper = node && node.closest ? node.closest('.mobile-facets__wrapper') : null;
    if (!wrapper) return;
    const details = wrapper.querySelector('.mobile-facets__disclosure');
    if (details) details.removeAttribute('open');
    wrapper.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-mobile');
  }

  function replaceTag(documentRef, root, selector, tagName = 'div') {
    root.querySelectorAll(selector).forEach((node) => {
      const replacement = documentRef.createElement(tagName);
      Array.from(node.attributes).forEach((attr) => replacement.setAttribute(attr.name, attr.value));
      replacement.innerHTML = node.innerHTML;
      node.replaceWith(replacement);
    });
  }

  function sanitizeNode(documentRef, node) {
    if (!node) return null;

    const clone = node.cloneNode(true);

    clone.querySelectorAll('script, style, link[rel="stylesheet"], noscript').forEach((el) => el.remove());

    replaceTag(documentRef, clone, 'facet-filters-form');
    replaceTag(documentRef, clone, 'facet-remove', 'span');
    replaceTag(documentRef, clone, 'price-range');
    replaceTag(documentRef, clone, 'show-more-button');

    clone.querySelectorAll('[id]').forEach((el) => {
      el.id = `${el.id}-overlay`;
    });

    clone.querySelectorAll('[aria-controls]').forEach((el) => {
      el.setAttribute('aria-controls', `${el.getAttribute('aria-controls')}-overlay`);
    });

    clone.querySelectorAll('[aria-labelledby]').forEach((el) => {
      const value = el.getAttribute('aria-labelledby');
      if (!value) return;
      el.setAttribute(
        'aria-labelledby',
        value
          .split(' ')
          .filter(Boolean)
          .map((item) => `${item}-overlay`)
          .join(' ')
      );
    });

    return clone;
  }

  function extractOverlayResults(doc) {
    const sourceDoc = doc;
    const wrapper = sourceDoc.createElement('div');
    wrapper.className = 'cap-search-overlay__results-shell';

    const sortBar = sourceDoc.querySelector('.facets-vertical-sort');
    const facetsGrid = sourceDoc.querySelector('.facets-vertical');
    const emptyCollection = sourceDoc.querySelector('.template-search__results.collection--empty');
    const status = sourceDoc.querySelector('.cap-search-status');
    const emptyActions = sourceDoc.querySelector('.cap-search-empty-actions');
    const fallbackResults = sourceDoc.querySelector('.template-search__results.collection');

    if (sortBar) wrapper.appendChild(sanitizeNode(sourceDoc, sortBar));

    if (facetsGrid) {
      wrapper.appendChild(sanitizeNode(sourceDoc, facetsGrid));
    } else if (emptyCollection) {
      if (status) wrapper.appendChild(sanitizeNode(sourceDoc, status));
      wrapper.appendChild(sanitizeNode(sourceDoc, emptyCollection));
      if (emptyActions) wrapper.appendChild(sanitizeNode(sourceDoc, emptyActions));
    } else if (fallbackResults) {
      if (status) wrapper.appendChild(sanitizeNode(sourceDoc, status));
      wrapper.appendChild(sanitizeNode(sourceDoc, fallbackResults));
    } else {
      const fallback = sourceDoc.createElement('div');
      fallback.className = 'cap-search-status cap-search-status--empty';
      fallback.textContent = 'Nessun risultato trovato.';
      wrapper.appendChild(fallback);
    }

    return wrapper.innerHTML;
  }

  async function fetchSearchResults(url, options = {}) {
    const normalizedUrl = typeof url === 'string' ? url : buildSearchUrl(url);
    const query = new URL(normalizedUrl, window.location.origin).searchParams.get('q') || '';
    rememberRecentTerm(query);

    if (!normalizeTerm(query)) {
      showEmptyState();
      return;
    }

    if (activeController) activeController.abort();
    activeController = new AbortController();
    showLoadingState();
    lastFetchedUrl = normalizedUrl;

    try {
      const response = await fetch(normalizedUrl, {
        credentials: 'same-origin',
        signal: activeController.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Search request failed: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const markup = extractOverlayResults(doc);

      dialogInput.value = normalizeTerm(query);
      toggleResetButton();
      showResultsState(markup);
      lastSearchedTerm = normalizeTerm(query);

      if (options.persist) {
        saveRecentTerm(query);
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      showResultsState('<div class="cap-search-status cap-search-status--empty">Errore durante la ricerca. Riprova.</div>');
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  function requestSearch(query, options = {}) {
    const normalized = normalizeTerm(query);
    window.clearTimeout(debounceTimer);

    if (!normalized) {
      showEmptyState();
      return;
    }

    debounceTimer = window.setTimeout(() => {
      fetchSearchResults(buildSearchUrl(normalized), options);
    }, options.immediate ? 0 : SEARCH_DELAY);
  }

  function serializeForm(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value === '' || value == null) continue;
      params.append(key, value);
    }

    return buildSearchUrl(params);
  }

  function syncOverlayQuery(value, options = {}) {
    const normalized = normalizeTerm(value);
    rememberRecentTerm(normalized);

    if (!isOpen) {
      openOverlay(normalized);
      return;
    }

    dialogInput.value = normalized;
    toggleResetButton();

    if (!normalized) {
      showEmptyState();
      return;
    }

    requestSearch(normalized, {
      persist: false,
      immediate: options.immediate !== false
    });
  }

  function triggerOpenFromHeader(event, initialValue = '') {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    openOverlay(initialValue);
  }

  renderRecentTerms();
  showEmptyState();

  if (headerInput) {
    headerInput.setAttribute('aria-haspopup', 'dialog');
    headerInput.setAttribute('autocomplete', 'off');
    headerInput.readOnly = true;

    headerInput.addEventListener('focus', (event) => {
      triggerOpenFromHeader(event, headerInput.value || '');
    });

    headerInput.addEventListener('click', (event) => {
      triggerOpenFromHeader(event, headerInput.value || '');
    });

    headerInput.addEventListener('pointerdown', (event) => {
      triggerOpenFromHeader(event, headerInput.value || '');
    });

    headerInput.addEventListener('keydown', (event) => {
      if (event.metaKey || event.ctrlKey || event.altKey) return;

      const printable = event.key && event.key.length === 1;
      const special = ['Backspace', 'Delete', 'Enter', ' '].includes(event.key);
      if (!printable && !special) return;

      event.preventDefault();
      syncOverlayQuery(printable ? event.key : '', { immediate: true });
    });

    headerInput.addEventListener('paste', (event) => {
      event.preventDefault();
      const pasted = (event.clipboardData || window.clipboardData)?.getData('text') || '';
      syncOverlayQuery(pasted, { immediate: true });
    });
  }

  if (headerButton) {
    headerButton.addEventListener('click', (event) => triggerOpenFromHeader(event, headerInput ? headerInput.value : ''));
  }

  if (headerForm) {
    headerForm.addEventListener('click', (event) => {
      const target = event.target;
      if (target && target.closest('.cap-search-btn')) return;
      if (!isOpen) triggerOpenFromHeader(event, headerInput ? headerInput.value : '');
    });

    headerForm.addEventListener('submit', (event) => triggerOpenFromHeader(event, headerInput ? headerInput.value : ''));
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeOverlay);
  });

  window.addEventListener('resize', () => {
    if (resultsState && !resultsState.hidden) {
      renderEnhancedMobileFilters(resultsState);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen) {
      closeOverlay();
    }
  });

  if (dialogInput) {
    dialogInput.addEventListener('input', () => {
      const currentValue = normalizeTerm(dialogInput.value);
      const hadPendingRecentTerm = normalizeTerm(pendingRecentTerm);

      if (currentValue) {
        rememberRecentTerm(currentValue);
      } else if (hadPendingRecentTerm) {
        saveRecentTerm(hadPendingRecentTerm);
      }

      toggleResetButton();
      requestSearch(dialogInput.value, { persist: false });
    });
  }

  if (dialogForm) {
    dialogForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const query = normalizeTerm(dialogInput ? dialogInput.value : '');
      rememberRecentTerm(query);
      if (!query) {
        showEmptyState();
        return;
      }
      fetchSearchResults(buildSearchUrl(query), { persist: true });
    });
  }

  if (resetButton) {
    resetButton.addEventListener('click', () => {
      if (!dialogInput) return;
      const termToSave = normalizeTerm(dialogInput.value || pendingRecentTerm || lastSearchedTerm);
      if (termToSave) {
        saveRecentTerm(termToSave);
      }
      dialogInput.value = '';
      toggleResetButton();
      showEmptyState();
      dialogInput.focus({ preventScroll: true });
    });
  }

  if (clearAllButton) {
    clearAllButton.addEventListener('click', clearRecentTerms);
  }

  if (recentList) {
    recentList.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-cap-search-remove-term]');
      if (removeButton) {
        event.preventDefault();
        removeRecentTerm(removeButton.getAttribute('data-cap-search-remove-term'));
        return;
      }

      const termButton = event.target.closest('[data-cap-search-term]');
      if (termButton) {
        event.preventDefault();
        const term = termButton.getAttribute('data-cap-search-term') || '';
        rememberRecentTerm(term);
        if (dialogInput) dialogInput.value = term;
        toggleResetButton();
        fetchSearchResults(buildSearchUrl(term), { persist: true });
      }
    });
  }

  resultsState.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    if (link.matches('[data-mobile-facets-clear]')) return;
    if (link.closest('form.mobile-facets, [id^="FacetFiltersFormMobile"]') && !link.matches('.pagination__item')) return;

    const href = link.getAttribute('href');
    if (!href) return;

    if (href.startsWith('/search') || href.startsWith('?')) {
      event.preventDefault();
      const url = href.startsWith('?') ? `${SEARCH_ROOT}${href}` : href;
      fetchSearchResults(url, { persist: false });
      return;
    }

    if (normalizeTerm(dialogInput.value)) {
      saveRecentTerm(dialogInput.value);
    } else if (pendingRecentTerm) {
      saveRecentTerm(pendingRecentTerm);
    } else if (lastSearchedTerm) {
      saveRecentTerm(lastSearchedTerm);
    }
    closeOverlay();
  });



  resultsState.addEventListener('click', (event) => {
    const clearAll = event.target.closest('.js-clear-all-facets');
    if (clearAll) {
      const mobileForm = clearAll.closest('form.mobile-facets') || clearAll.closest('[id^="FacetFiltersFormMobile"]');
      if (mobileForm) {
        event.preventDefault();
        clearMobileFacetsForm(mobileForm);
        return;
      }
      event.preventDefault();
      fetchSearchResults(clearAll.getAttribute('href') || buildSearchUrl(dialogInput ? dialogInput.value : ''), { persist: false });
      return;
    }

    const chipButton = event.target.closest('.mobile-facets__chip');
    if (chipButton) {
      const mobileForm = chipButton.closest('form.mobile-facets') || chipButton.closest('[id^="FacetFiltersFormMobile"]');
      if (!mobileForm) return;
      event.preventDefault();
      if (chipButton.getAttribute('data-mobile-chip-type') === 'price') {
        mobileForm.querySelectorAll('.facets__price input').forEach((input) => {
          input.value = '';
        });
      } else {
        const name = chipButton.getAttribute('data-mobile-chip-name');
        const value = chipButton.getAttribute('data-mobile-chip-value');
        const input = mobileForm.querySelector(`input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`);
        if (input) input.checked = false;
      }
      updateMobileFacetsUI(mobileForm);
      return;
    }

    const mobileLabel = event.target.closest('.mobile-facets__label');
    if (mobileLabel && !event.target.closest('input, a, button, select, option, summary')) {
      const checkbox = mobileLabel.querySelector('input[type="checkbox"], input[type="radio"]');
      if (checkbox && !checkbox.disabled) {
        event.preventDefault();
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  });

  resultsState.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-cap-open-filter]');
    if (openButton) {
      event.preventDefault();
      openEnhancedMobileSheet(resultsState, openButton.getAttribute('data-cap-open-filter') || '');
      return;
    }

    const sheetClose = event.target.closest('[data-cap-sheet-close]');
    if (sheetClose) {
      event.preventDefault();
      closeEnhancedMobileSheet(resultsState);
      return;
    }

    const clearAllButton = event.target.closest('[data-cap-mobile-clear-all]');
    if (clearAllButton) {
      const mobileForm = getMobileFacetsForm(resultsState);
      if (!mobileForm) return;
      event.preventDefault();
      clearMobileFacetsForm(mobileForm);
      submitMobileFacetsForm(mobileForm, { buttonText: 'Aggiorno...' });
      return;
    }

    const chip = event.target.closest('.cap-mobile-chip');
    if (chip) {
      const mobileForm = getMobileFacetsForm(resultsState);
      if (!mobileForm) return;
      event.preventDefault();
      if (chip.getAttribute('data-cap-chip-type') === 'price') {
        mobileForm.querySelectorAll('.facets__price input').forEach((input) => {
          input.value = '';
        });
      } else {
        const name = chip.getAttribute('data-cap-chip-name');
        const value = chip.getAttribute('data-cap-chip-value');
        const targetInput = mobileForm.querySelector(`input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`);
        const isCategoryChip = !!(targetInput && targetInput.closest('[data-mobile-category-filter="true"]'));
        if (isCategoryChip) {
          const chipLabel = (chip.textContent || '').replace(/×/g, '').trim() || 'questa categoria';
          if (!window.confirm(`Rimuovere il filtro "${chipLabel}"?`)) return;
        }
        if (targetInput) targetInput.checked = false;
      }
      updateMobileFacetsUI(mobileForm);
      submitMobileFacetsForm(mobileForm, { buttonText: 'Aggiorno...' });
      return;
    }

    const sheet = event.target.closest('.cap-mobile-filter-sheet');
    if (!sheet) return;

    const mobileForm = getMobileFacetsForm(resultsState);
    if (!mobileForm) return;

    const activeKey = sheet.dataset.filterKey;
    const definition = getMobileFilterDefinitions(mobileForm).find((item) => item.key === activeKey);
    if (!definition) return;

    const treeToggle = event.target.closest('[data-cap-tree-toggle]');
    if (treeToggle) {
      event.preventDefault();
      const wrap = treeToggle.closest('.cap-mobile-category-branch-wrap');
      const children = wrap ? wrap.querySelector('.cap-mobile-category-children') : null;
      const expanded = treeToggle.getAttribute('aria-expanded') === 'true';
      const treeRoot = sheet.querySelector('.cap-mobile-category-tree');

      if (treeRoot) {
        treeRoot.querySelectorAll('.cap-mobile-category-branch-wrap.is-open').forEach((openWrap) => {
          if (openWrap === wrap) return;
          openWrap.classList.remove('is-open');
          const openButton = openWrap.querySelector('[data-cap-tree-toggle]');
          const openChildren = openWrap.querySelector('.cap-mobile-category-children');
          if (openButton) openButton.setAttribute('aria-expanded', 'false');
          if (openChildren) openChildren.hidden = true;
        });
      }

      treeToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (wrap) wrap.classList.toggle('is-open', !expanded);
      if (children) children.hidden = expanded;
      return;
    }

    const removeActiveCategory = event.target.closest('[data-cap-tree-remove-active]');
    if (removeActiveCategory && definition.kind === 'list' && definition.singleSelectImmediate) {
      event.preventDefault();
      const optionId = removeActiveCategory.getAttribute('data-cap-tree-remove-active');
      const options = getCategoryOptionObjects(definition.source);
      const label = formatCategoryRemovalLabel(buildCategoryTreeNodes(CATEGORY_TREE, options), options, optionId);
      if (!window.confirm(`Rimuovere il filtro "${label}"?`)) return;
      definition.source.querySelectorAll('.mobile-facets__checkbox').forEach((input) => {
        input.checked = false;
      });
      updateMobileFacetsUI(mobileForm);
      submitMobileFacetsForm(mobileForm, { buttonText: 'Rimuovo categoria...' });
      closeEnhancedMobileSheet(resultsState);
      return;
    }

    const treeSelect = event.target.closest('[data-cap-tree-select]');
    if (treeSelect && definition.kind === 'list' && definition.singleSelectImmediate) {
      event.preventDefault();
      const optionId = treeSelect.getAttribute('data-cap-tree-select');
      const options = getCategoryOptionObjects(definition.source);
      const picked = options.find((option) => option.id === optionId);
      if (!picked || picked.disabled) return;

      if (picked.checked) {
        const label = formatCategoryRemovalLabel(buildCategoryTreeNodes(CATEGORY_TREE, options), options, picked.id);
        if (!window.confirm(`Rimuovere il filtro "${label}"?`)) return;
        definition.source.querySelectorAll('.mobile-facets__checkbox').forEach((input) => {
          input.checked = false;
        });
        updateMobileFacetsUI(mobileForm);
        submitMobileFacetsForm(mobileForm, { buttonText: 'Rimuovo categoria...' });
        closeEnhancedMobileSheet(resultsState);
        return;
      }

      definition.source.querySelectorAll('.mobile-facets__checkbox').forEach((input) => {
        input.checked = false;
      });
      picked.input.checked = true;
      updateMobileFacetsUI(mobileForm);
      submitMobileFacetsForm(mobileForm, { buttonText: 'Aggiorno categoria...' });
      closeEnhancedMobileSheet(resultsState);
      return;
    }

    const sortOption = event.target.closest('[data-cap-sheet-sort-value]');
    if (sortOption) {
      event.preventDefault();
      definition.source.value = sortOption.getAttribute('data-cap-sheet-sort-value') || definition.source.value;
      submitMobileFacetsForm(mobileForm, { buttonText: 'Ordino...' });
      closeEnhancedMobileSheet(resultsState);
      return;
    }

    const listOption = event.target.closest('[data-cap-sheet-name]');
    if (listOption && definition.kind === 'list') {
      event.preventDefault();
      const optionName = listOption.getAttribute('data-cap-sheet-name');
      const optionValue = listOption.getAttribute('data-cap-sheet-value');

      if (definition.singleSelectImmediate) {
        const targetInput = definition.source.querySelector(`input[name="${CSS.escape(optionName)}"][value="${CSS.escape(optionValue)}"]`);
        const wasChecked = !!(targetInput && targetInput.checked);
        definition.source.querySelectorAll('.mobile-facets__checkbox').forEach((input) => {
          input.checked = false;
        });
        if (targetInput) {
          targetInput.checked = !wasChecked;
        }
        updateMobileFacetsUI(mobileForm);
        submitMobileFacetsForm(mobileForm, { buttonText: 'Aggiorno categoria...' });
        closeEnhancedMobileSheet(resultsState);
        return;
      }

      listOption.classList.toggle('is-selected');
      return;
    }

    const clearButton = event.target.closest('[data-cap-sheet-clear]');
    if (clearButton) {
      event.preventDefault();
      if (definition.kind === 'price') {
        sheet.querySelectorAll('[data-cap-sheet-price]').forEach((input) => {
          input.value = '';
        });
      } else {
        sheet.querySelectorAll('[data-cap-sheet-name]').forEach((option) => option.classList.remove('is-selected'));
      }
      return;
    }

    const applyButton = event.target.closest('[data-cap-sheet-apply]');
    if (applyButton) {
      event.preventDefault();
      if (definition.kind === 'price') {
        const sourceInputs = Array.from(definition.source.querySelectorAll('.facets__price input')).filter((input) => !input.disabled);
        const min = sheet.querySelector('[data-cap-sheet-price="min"]');
        const max = sheet.querySelector('[data-cap-sheet-price="max"]');
        if (sourceInputs[0]) sourceInputs[0].value = min ? min.value : '';
        if (sourceInputs[1]) sourceInputs[1].value = max ? max.value : '';
      } else {
        const selected = new Set(Array.from(sheet.querySelectorAll('[data-cap-sheet-name].is-selected')).map((option) => `${option.getAttribute('data-cap-sheet-name')}::${option.getAttribute('data-cap-sheet-value')}`));
        definition.source.querySelectorAll('.mobile-facets__checkbox').forEach((input) => {
          input.checked = selected.has(`${input.name}::${input.value}`);
        });
      }
      updateMobileFacetsUI(mobileForm);
      submitMobileFacetsForm(mobileForm, { buttonText: 'Aggiorno...' });
      closeEnhancedMobileSheet(resultsState);
    }
  });

  resultsState.addEventListener('submit', (event) => {
    const form = event.target.closest('form');
    if (!form) return;

    event.preventDefault();
    submitOverlayForm(form, { closeDrawerOnDone: isMobileFacetsForm(form) });
  });

  resultsState.addEventListener('change', (event) => {
    const target = event.target;
    const form = target && target.closest('form');
    if (!form) return;

    if (isMobileFacetsForm(form)) {
      const categoryDetails = target.closest('[data-mobile-category-filter="true"]');
      const isCategoryCheckbox = categoryDetails && target.matches('.mobile-facets__checkbox');

      if (isCategoryCheckbox) {
        if (target.checked) {
          categoryDetails.querySelectorAll('.mobile-facets__checkbox').forEach((input) => {
            if (input !== target) input.checked = false;
          });
        }

        updateMobileFacetsUI(form);
        submitOverlayForm(form, {
          closeDrawerOnDone: true,
          buttonText: 'Aggiorno categoria...'
        });
        return;
      }

      updateMobileFacetsUI(form);
      return;
    }

    const isImmediate =
      target.matches('select') ||
      target.matches('input[type="checkbox"]') ||
      target.matches('input[type="radio"]');

    if (!isImmediate) return;
    fetchSearchResults(serializeForm(form), { persist: false });
  });
})();
